import { inject, Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { AttachmentService } from '../../core/services/attachment';
import * as invoiceAttachmentsActions from '../actions/invoice-attachments.action';

@Injectable()
export class InvoiceAttachmentEffects {
  private actions$ = inject(Actions);

  private attachmentService = inject(AttachmentService);

  loadInvoiceAttachments$ = createEffect(() =>
    this.actions$.pipe(
      ofType(invoiceAttachmentsActions.LOAD_INVOICE_ATTACHMENTS),
      switchMap(() =>
        this.attachmentService.getInvoiceFiles().pipe(
          map(
            (files) =>
              new invoiceAttachmentsActions.LoadInvoiceAttachmentsSuccess(
                files,
              ),
          ),
          catchError((error) =>
            of(new invoiceAttachmentsActions.LoadInvoiceAttachmentsFail(error)),
          ),
        ),
      ),
    ),
  );
}
